<template>
  <div v-if="loaded"
       class="boxAddFilhos">
    <div class="boxAddFilhos_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="boxAddFilhos_header_title">
            Filhos
          </h2>
        </div>
      </div>
    </div>

    <div class="px-2">
      <div class="form-group">
        <label
          class="label d-block"
          for="">Deixa Filhos</label>
        <span class="custom-control custom-radio custom-control-inline">
          <input
            id="filhosNao"
            v-model="localData.deixa_filhos"
            type="radio"
            name="filhosNao"
            :value="false"
            class="custom-control-input"
            @click="deixaFilhos(false)"
            @keyup.enter="deixaFilhos(false)">
          <label
            class="custom-control-label"
            for="filhosNao">Não</label>
        </span>
        <span class="custom-control custom-radio custom-control-inline">
          <input
            id="filhosSim"
            v-model="localData.deixa_filhos"
            type="radio"
            name="filhosSim"
            :value="true"
            class="custom-control-input"
            @click="deixaFilhos(true)"
            @keyup.enter="deixaFilhos(true)">
          <label
            class="custom-control-label"
            for="filhosSim">Sim</label>
        </span>
      </div>
    </div>

    <div
      v-if="localData.deixa_filhos === true"
      class="boxAddFilhos_body">
      <BoxFilho
        v-for="(filhoFor, index) in localData.filhoDeixado"
        :key="index"
        :prop-index="index"
        :prop-filho="filhoFor"
        @edit="edit(filhoFor, index)"
        @remove="(filho, index) => remove(filho, index)" />

      <button
        v-b-modal.addFilho
        class="btn btn-add-filho btn-sm btn-outline-primary btn-block mb-3"
        type="button"
        @click="modalAdd = true">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar filho
      </button>
    </div>


    <b-modal
      v-if="modalAdd"
      id="addFilho"
      ref="modalAddFilho"
      modal-class="modalAddFilhos"
      body-class="modalAddFilhos_body"
      :hide-header="true"
      :visible="true"
      centered
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      @ok="modalChange"
      @hide="modalChange">
      <div class="mt-3">
        <FormAddFilhos
          :prop-filho="filho"
          @filhoAdded="getFilho" />
      </div>

      <div
        slot="modal-footer"
        slot-scope="{ ok, cancel }"
        class="modalAddFilhos_footer">
        <button
          class="btn btn-sm btn-dark mr-2"
          @click="cancel()">
          Voltar
        </button>
        <button
          id="btn_filhos_continue"
          class="btn btn-sm btn-primary"
          type="button"
          :disabled="!filho.nome"
          @click="addFilho">
          Continuar
        </button>
      </div>
    </b-modal>

    <b-modal
      v-if="modalEdit"
      id="editFilho"
      ref="modalEditFilho"
      modal-class="modalEditFilho"
      body-class="modalEditFilho_body"
      :hide-header="true"
      :visible="true"
      centered
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      @ok="modalChange"
      @hide="modalChange">
      <div class="mt-3">
        <FormAddFilhos
          :prop-filho="editFilho"
          @filhoAdded="getFilhoUpdate" />
      </div>

      <div
        slot="modal-footer"
        slot-scope="{ ok, cancel }"
        class="modalEditFilho_footer">
        <button
          class="btn btn-sm btn-dark mr-2"
          @click="cancel()">
          Voltar
        </button>
        <button
          class="btn btn-sm btn-primary"
          type="button"
          :disabled="!editFilho.nome"
          @click="updateFilho">
          Atualizar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import FormAddFilhos from '../../Forms/FormAddFilhos.vue'
  import BoxFilho from '@/components/SofiaRei/Obito/BoxFilho.vue'

  /* services */
  import FilhosService from "@/services/Registros/Obito/FilhosService"

  export default {
    name: 'Filhos',
    components: { FormAddFilhos, BoxFilho },
    props: {
      propData: { type: Object, default: () => ({})  },
      readOnly: { type: Boolean, default: ()=> false }
    },
    data () {
      return {
        filho: {
          idade_tipo: 'A'
        },
        localData: {
          deixa_filhos: false,
          filhoDeixado: []
        },
        loaded: false,
        editFilho: {},
        modalAdd: false,
        modalEdit: false
      }
    },
    watch: {
      'propData.filhoDeixado' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.localData.deixa_filhos = (this.propData.filhoDeixado.length > 0 || !!this.propData.deixa_filhos) || false

        this.localData.filhoDeixado = this.propData.filhoDeixado

        this.loaded = true
      },
      deixaFilhos (value) {
        this.localData.deixa_filhos = value
        this.$emit('deixaFilhos', value)
      },
      async addFilho () {
        try {
          let filho = this.filho
          if (!this.readOnly) {
            filho = await FilhosService.storeFilhos(this.$route.params.id, this.filho)
          }
          this.$emit('filhoAdded', filho)
          // this.$refs.modalAddFilho.hide()
          this.filho = {}
        } catch (err) {
          objSwal.error.title = 'Erro ao Cadastrar'
          objSwal.error.text = err.message
          return Swal.fire(objSwal.error)
        } finally {
          this.modalChange()

          objSwal.question.title = "Filho adicionado com sucesso"
          objSwal.question.confirmButtonText = "Adicionar outro"
          objSwal.question.cancelButtonText = "Continuar"

          // O box shadow com o focus está trocado, então selecionamos o corfirm
          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 50)

          Swal.fire(objSwal.question).then(res => {
            const { value } = res

            if (value) {
              this.modalAdd = true
            } else {
              const btn = document.querySelector('.btn-add-filho')

              if (btn) btn.focus()
            }

            objSwal.question.title = ""
            objSwal.question.confirmButtonText = "Confirmar"
            objSwal.question.cancelButtonText = "Voltar"
          })
        }
      },

      async updateFilho () {
        try {
          if (!this.readOnly) {
            await FilhosService.updateFilho(this.editFilho.filho_deixado_id, {...this.editFilho })
          }
          this.$emit('filhoUpdated', this.editFilho)
          // this.$refs.modalEditFilho.hide()
          objSwal.success.title = "Atualizado com Sucesso"
          objSwal.success.text = ''

          Swal.fire(objSwal.success).then(res => {
            const { value } = res

            if (value) {
              const btn = document.querySelector('.btn-add-filho')

              if (btn) btn.focus()
            }
          })
        } catch (err) {
          objSwal.error.title = 'Erro ao Atualizar'
          objSwal.error.text = err.message
          return Swal.fire(objSwal.error)
        } finally {
          setTimeout(() => {
            const btnContinuar = document.querySelector('.swal2-confirm')

            if (btnContinuar) btnContinuar.focus()
          }, 50)

          this.modalChange()
        }
      },

      getFilho (filho) {
        this.filho = filho
      },

      getFilhoUpdate (filho) {
        this.editFilho = filho
      },

      modalChange () {
        this.modalAdd = false
        this.modalEdit = false
        this.filho = {}
        this.editFilho = {}
      },

      edit (filhoEdit, localId) {
        this.modalEdit = true
        Object.assign(this.editFilho, filhoEdit)
        this.editFilho.localId = localId
        // this.$refs.modalEditFilho.show()
      },

      async remove (filho, index) {
        try {
          if (!this.readOnly) {
            await FilhosService.deleteFilho(filho.filho_deixado_id)
          }
          this.$emit('filhoRemoved', filho, index)
          objSwal.success.title = "Removido com Sucesso"
          objSwal.success.text = ''
          Swal.fire(objSwal.success)
        } catch (err) {
          objSwal.error.title = 'Erro ao Remover'
          objSwal.error.text = err.message
          return Swal.fire(objSwal.error)
        } finally {
          this.modalChange()
        }
      }

    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .boxAddFilhos {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }

  .modalAddFilhos {
    &_body {
      border-bottom: pxToRem(1) solid $sinoreg-blue;
      margin: 0 pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    .modal-footer {
      border: none;
    }
  }

  .btn-add-filho:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
